const LENDING_PROGRAM_REDUCER_PATH = "lendingProgramService";
const LENDER_PORTAL_LENDING_PROGRAM_REDUCER_PATH = "lenderPortalProgramService";
const LENDING_PROGRAM_SERVICE_TAG = "LENDING_PROGRAM";
const LENDING_PROGRAM_DETAIL_SERVICE_TAG = "LENDING_PROGRAM_DETAIL";

const LENDING_PROGRAM_RELATED_TAGS = [LENDING_PROGRAM_SERVICE_TAG, LENDING_PROGRAM_DETAIL_SERVICE_TAG];

export {
  LENDING_PROGRAM_REDUCER_PATH,
  LENDER_PORTAL_LENDING_PROGRAM_REDUCER_PATH,
  LENDING_PROGRAM_SERVICE_TAG,
  LENDING_PROGRAM_DETAIL_SERVICE_TAG,
  LENDING_PROGRAM_RELATED_TAGS,
};
